import { StandardEvents } from '@shopify/events';

/**
 * Sends the shopper to /cart after any successful add to bag.
 *
 * Every product-form surface (PDP, sticky bar, quick-add popup, configurator,
 * hotspots) dispatches a bubbling `cart:lines-update` event whose promise
 * resolves once the add is confirmed. Failed adds resolve with `didError` or
 * reject, so the form keeps its inline error. Independent of the cart drawer,
 * which is not rendered when the theme's cart type is "page".
 *
 * Not loaded on the cart template (see snippets/scripts.liquid).
 */

let redirecting = false;

/** @param {any} event */
function onCartLinesUpdate(event) {
  if (event?.action !== 'add' || !event.promise) return;

  event.promise
    .then((/** @type {any} */ result) => {
      if (redirecting || result?.detail?.didError) return;
      redirecting = true;
      // `Theme` is a global binding, not a window property, so window.Theme is always undefined.
      // Read it directly, or US and EU shoppers land on the UK /cart and are repriced in GBP.
      window.location.assign(typeof Theme !== 'undefined' && Theme.routes?.cart_url ? Theme.routes.cart_url : '/cart');
    })
    .catch(() => {
      // Add failed or was aborted; the form already shows its error.
    });
}

if (!window.__amadaCartRedirect) {
  window.__amadaCartRedirect = true;
  document.addEventListener(StandardEvents.cartLinesUpdate, onCartLinesUpdate);
}
